import './DescricaoProblema.css'

import {useState, useEffect} from 'react'
import {motion} from 'motion/react'
import Avatar from '../Avatar/Avatar'

export default function DescricaoProblema({requester, description}){
    
    const [mensagem, setMensagem] = useState(" ")

    const [mostrarMensagem, setMostrarMensagem] = useState(false)

    const mensagens = [
        "Oi, conseguiu verificar?",
        "Algum retorno?",
        "Já conseguiu ver meu chamado?",
        "Tem alguma novidade?",
        "Tem alguma previsão de conclusão?",
        "Acho que é simples de resolver",
        "Não mexi em nada",
        "Consegue me dar uma previsão?"
    ]

    const gerarMensagem=()=>{
        const m = mensagens[Math.floor(Math.random() * mensagens.length)];
        setMensagem(m)
        setMostrarMensagem(true)
        console.log(mensagem)
    }

    const somPopUp = () =>{
        const audio = new Audio('sounds/popUp.mp3')
        audio.play().catch(error => console.log("Áudio bloqueado:", error))
    }

    useEffect(()=>{
        setTimeout(()=>{
            gerarMensagem()
        },10000)
    },[])


    return(
        <div className="descricaoProblema">
            <div>
                {mostrarMensagem ?
                    <motion.div
                        initial={{ opacity: 0, scale: 0.7, y: 10 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        transition={{ type: "spring", stiffness: 400, damping: 15 }}
                        onAnimationStart={somPopUp}
                        className="balaoFala"> 
                            <p>{mensagem}</p>  
                    </motion.div>: ""}
               
                <Avatar nome={requester} className="quadrado" />
            </div>

           <div className="areaTextoDescricaoProblema">
                <h4>{requester}:</h4> 
                <p>
                    {description}
                </p>
           </div>

        </div>
    )
}